import { render, staticRenderFns } from "./addSwitch.vue?vue&type=template&id=3a6d6fa7&scoped=true"
import script from "./addSwitch.vue?vue&type=script&lang=js"
export * from "./addSwitch.vue?vue&type=script&lang=js"
import style0 from "./addSwitch.vue?vue&type=style&index=0&id=3a6d6fa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d6fa7",
  null
  
)

export default component.exports